import { AddAddress } from 'domain/usecases/address/add-address'
import { AddressRepository } from 'repository/interfaces/address-repository'

export class RemoteAddAddress implements AddAddress {
  private readonly addressRepository: AddressRepository

  constructor(addressRepository: AddressRepository) {
    this.addressRepository = addressRepository
  }

  add(params: AddAddress.Params): Promise<AddAddress.Model> {
    return this.addressRepository.addAddress(params)
  }
}
